import { fg } from '@atlassian/jira-feature-gating';

type JswCmpCardCoversExpCohort = 'experiment' | 'control';

// This function will be used to determine if a user is part of the 'experiment' cohort
// in the JSW Card Covers Experiment.
// We are currently only checking the feature gate as we have yet to set up the experiment
// but we need this value to be sent in analytic events to unblock other dev work
// TODO: PNDR-2061 - Implement returning statsig experiment exposure once we've set up the experiment
export const isJswCmpCardCoversExpCohort = (): JswCmpCardCoversExpCohort =>
	fg('jsw_cmp_card_cover_images') ? 'experiment' : 'control';
